var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.assets},scopedSlots:_vm._u([{key:"item.access_level",fn:function(ref){
var item = ref.item;
return [_c('v-chip',{attrs:{"color":"#7986cb","dark":""}},[_vm._v(" "+_vm._s(item.access_level)+" ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }